import React from "react";
import { styled } from '@mui/material/styles';
import { CircularProgress } from "@mui/material";
const PREFIX = 'Loading';

const classes = {
  fullWidth: `${PREFIX}-fullWidth`,
  loader: `${PREFIX}-loader`
};

const Root = styled('div')({
  [`&.${classes.fullWidth}`]: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  [`& .${classes.loader}`]: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: "column",
  },
});

export default function Loading(props) {
  return (
    <Root>
      <div className={classes.fullWidth}>
        <div className={classes.loader}>
          <CircularProgress color="primary" />
          <span>{props.message}</span>
        </div>
      </div>
    </Root>
  );
}
